import { Dispatch } from "redux";
import { connect } from "react-redux";

import Login from "./login";
import { AppState } from "../../core/reducers/rootReducer";
import { AuthActions } from "../../core/actionTypes/authActionTypes";
import { ibAuthenticate } from "../../core/actionCreators/authActionCreators";
import * as authActionTypes from "../../core/actionTypes/authActionTypes";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";

const mapDispatchToProps = (dispatch: Dispatch<AuthActions>) => ({
  onLogin: (request: object) => {
    dispatch(ibAuthenticate(request));
  }
});

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    authResponse: state.auth.authResponse,
    partnerData: state.auth,
    isLoading: state.isLoading[authActionTypes.GET_IB_AUTHENTICATION],
    authError: state.error[authActionTypes.GET_IB_AUTHENTICATION],
    isAuthenticated: isUserLoggedIn(txnId),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
